module.exports = __webpack_public_path__ + "static/media/water-polo.86e0be0a.svg";